export default __webpack_public_path__ + "static/media/logo.d53be03e.svg";